import Form from "../views/Form"
import CodeAccess from "../views/CodeAccess"
import Reply from "../views/Reply"

export default {
    routes: [
        {
            path: "/",
            name: "CodeAccess",
            component: CodeAccess,
        },
        {
            path: "/:hash",
            name: "FormByLink",
            component: Form,
        },
        {
            path: "/:hash/embedded/iframe/",
            name: "FormByLink",
            component: Form,
            props: {embedded: true}
        },
        {
            path: "/code/:code",
            name: "FormByCode",
            component: Form,
        },
        {
            path: "/code/:code/embedded/iframe/",
            name: "FormByCode",
            component: Form,
            props: {embedded: true}
        },
        {
            path: "/reply/:replyId",
            name: "Reply",
            component: Reply,
        },
        {
            path: "/preview/:formId",
            name: "Preview",
            component: Form,
        }
    ],
    mode: "history"
};